// extracted by mini-css-extract-plugin
export var brandLogo = "MenuLangingPage-module--brand-logo--da92d";
export var header = "MenuLangingPage-module--header--7c78d";
export var headerContainer = "MenuLangingPage-module--header-container--05006";
export var phone = "MenuLangingPage-module--phone--181f9";
export var secondaryNavItems = "MenuLangingPage-module--secondary-nav-items--ebbc9";
export var showLinksOnMobile = "MenuLangingPage-module--show-links-on-mobile--93918";